import Vue from 'vue';
import convertBytesToHumanReadable from 'human-readable-bytes';

Vue.filter('filesize', function(bytes, decimalPlaces = 0, space = true, method = 1024) {
  return convertBytesToHumanReadable(bytes, method, decimalPlaces, space);
});
